import { create } from 'zustand';
import { AdsCampaign, CampaignSettings } from '../types/ads';

interface AdsStore {
  campaigns: AdsCampaign[];
  selectedCampaign: AdsCampaign | null;
  setSelectedCampaign: (campaign: AdsCampaign | null) => void;
  createCampaign: (campaign: AdsCampaign) => void;
  updateCampaign: (id: string, updates: Partial<AdsCampaign>) => void;
  deleteCampaign: (id: string) => void;
  updateCampaignStatus: (id: string, status: AdsCampaign['status']) => void;
  updateCampaignBudget: (
    id: string,
    budget: AdsCampaign['budget']
  ) => void;
  updateSelectedClinicians: (id: string, clinicianIds: string[]) => void;
}

export const useAdsStore = create<AdsStore>((set) => ({
  campaigns: [],
  selectedCampaign: null,
  setSelectedCampaign: (campaign) => set({ selectedCampaign: campaign }),
  createCampaign: (campaign) =>
    set((state) => ({ campaigns: [...state.campaigns, campaign] })),
  updateCampaign: (id, updates) =>
    set((state) => ({
      campaigns: state.campaigns.map((c) =>
        c.id === id ? { ...c, ...updates } : c
      ),
    })),
  deleteCampaign: (id) =>
    set((state) => ({
      campaigns: state.campaigns.filter((c) => c.id !== id),
    })),
  updateCampaignStatus: (id, status) =>
    set((state) => ({
      campaigns: state.campaigns.map((c) =>
        c.id === id ? { ...c, status } : c
      ),
    })),
  updateCampaignBudget: (id, budget) =>
    set((state) => ({
      campaigns: state.campaigns.map((c) =>
        c.id === id ? { ...c, budget } : c
      ),
    })),
  updateSelectedClinicians: (id, clinicianIds) =>
    set((state) => ({
      campaigns: state.campaigns.map((c) =>
        c.id === id ? { ...c, selectedClinicians: clinicianIds } : c
      ),
    })),
}));